// counter.js
import { useEffect, useRef, useState } from "react";

export default function CountUp({ to, duration = 1600 }) {
  const ref = useRef(null);
  const [val, setVal] = useState(0);
  const [started, setStarted] = useState(false);

  // Start when the element is in view
  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let obs;
    if ("IntersectionObserver" in window) {
      obs = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && !started) setStarted(true);
        },
        { threshold: 0.4 }
      );
      obs.observe(el);
    } else {
      setStarted(true);
    }
    return () => obs && el && obs.unobserve(el);
  }, [started]);

  // Animate 0 -> to
  useEffect(() => {
    if (!started) return;

    let rafId;
    const t0 = performance.now();

    const tick = (now) => {
      const t = Math.min(1, (now - t0) / duration);
      const eased = 1 - Math.pow(1 - t, 3); // smooth ease-out
      setVal(Math.round(eased * to));
      if (t < 1) rafId = requestAnimationFrame(tick);
    };

    rafId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafId);
  }, [started, to, duration]);

  return <span ref={ref}>{val.toLocaleString()}</span>;
}
